import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

function NotFoundPage() {
  const { t } = useTranslation()
  return (
    <div style={{ textAlign: 'center', padding: '4rem 2rem' }}>
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.message')}</p>
      <Link to='/' style={{ color: '#0066cc', textDecoration: 'underline' }}>
        {t('notFound.goHome')}
      </Link>
    </div>
  )
}

export default NotFoundPage
